import { ReactNode } from "react";
import { PlacementWithLogical, Tooltip, TooltipProps } from "@chakra-ui/react";

interface Props extends TooltipProps {
  label: string;
  placement?: PlacementWithLogical;
  children: ReactNode;
}

const TooltipComponent = ({
  label,
  placement = "top",
  children,
  ...rest
}: Props) => {
  return (
    <Tooltip
      hasArrow
      shouldWrapChildren
      label={label}
      placement={placement}
      bg="brand.toolTipBg"
      color="brand.toolTipText"
      fontSize="14px"
      p="0.5rem 1rem"
      borderRadius="8px"
      textAlign="center"
      {...rest}
    >
      {children}
    </Tooltip>
  );
};

export default TooltipComponent;
